var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pageInfo.page,"page-size":_vm.pageInfo.pagesize,"total":_vm.pageInfo.count,"page-sizes":[10, 20, 50],"layout":"total, sizes, prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }